import React from "react";

import { renderToStaticMarkup } from "react-dom/server";

import TooltipLines from "@/src/components/tooltip/TooltipLines";
import { APP_TOOLTIP_ID } from "@/src/constants/tooltip";

import DataTableStatusDot from "./DataTableStatusDot";

import type { JSX } from "react";

import type { StatusTone } from "./dataTable.types";

interface DataTableStatusCellProps {
  label: string;
  tone: StatusTone;
  tooltip?: string[];
}

function DataTableStatusCell({
  label,
  tone,
  tooltip,
}: DataTableStatusCellProps): JSX.Element {
  // Des lignes toutes vides (ex. une raison non traduite) valent une absence.
  const tooltipLineList = tooltip?.filter(Boolean) ?? [];

  return (
    <span
      className="inline-flex align-middle"
      data-tooltip-content={tooltipLineList.length ? undefined : label}
      data-tooltip-id={APP_TOOLTIP_ID}
      data-tooltip-html={
        tooltipLineList.length
          ? renderToStaticMarkup(<TooltipLines lines={tooltipLineList} />)
          : undefined
      }
    >
      <DataTableStatusDot tone={tone} />
      <span className="sr-only">{label}</span>
    </span>
  );
}

export default DataTableStatusCell;
